// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationProcedureId } from './FermentationProcedure';
import { fermentationProtocolId } from './FermentationProtocol';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationProcedureProtocolId = (z.number());
export const fermentationProcedureProtocol = z.object({
    id: fermentationProcedureProtocolId,
    procedure_id: fermentationProcedureId,
    protocol_id: fermentationProtocolId,
    position: z.number(),
    offset_h: z.string(),
    default_transition_h: z.string().nullable(),
    notes: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const fermentationProcedureProtocolInitializer = z.object({
    id: fermentationProcedureProtocolId.optional(),
    procedure_id: fermentationProcedureId,
    protocol_id: fermentationProtocolId,
    position: z.number(),
    offset_h: z.string(),
    default_transition_h: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const fermentationProcedureProtocolMutator = z.object({
    id: fermentationProcedureProtocolId.optional(),
    procedure_id: fermentationProcedureId.optional(),
    protocol_id: fermentationProtocolId.optional(),
    position: z.number().optional(),
    offset_h: z.string().optional(),
    default_transition_h: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationProcedureProtocol.js.map